module.exports = __webpack_public_path__ + "img/PINTAR.4a553ab0.png";